import { createApp, App } from 'vue'
import ToastComponent from './index.vue'

// Toast配置接口
export interface ToastOptions {
  duration?: number
}

// Toast实例接口
export interface ToastInstance {
  show: () => void
  hide: () => void
}

// Toast管理器类
class ToastManager {
  private instances: ToastInstance[] = []

  // 显示Toast
  show(message: string, options = { duration: 1000 } as ToastOptions): ToastInstance {
    const container = document.createElement('div')
    document.body.appendChild(container)

    const app = createApp(ToastComponent, {
      message,
      duration: options?.duration || 3000,
    })

    const instance = app.mount(container) as any
    this.instances.push(instance)

    // 自动清理
    setTimeout(() => {
      this.hide(instance)
    }, options?.duration || 3000)

    return instance
  }

  // 隐藏指定Toast
  hide(instance: ToastInstance) {
    const index = this.instances.indexOf(instance)
    if (index > -1) {
      instance.hide()
      this.instances.splice(index, 1)
    }
  }

  // 隐藏所有Toast
  hideAll() {
    this.instances.forEach(instance => instance.hide())
    this.instances = []
  }
}

// 创建全局Toast管理器实例
const toastManager = new ToastManager()

// 导出Toast方法
export const toast = {
  show: (message: string, options?: ToastOptions) => toastManager.show(message, options),
  hideAll: () => toastManager.hideAll(),
}

export type ToastGlobal = {
  show: (message: string, options?: ToastOptions) => ToastInstance
  hideAll: () => void
}

// 全局注册Toast插件
export const ToastPlugin = {
  install(app: App) {
    // 将toast方法挂载到全局属性
    app.config.globalProperties.$toast = toast

    // 提供inject/provide支持
    app.provide('$toast', toast)
  },
}

// 默认导出
export default ToastPlugin
